module.exports = __webpack_public_path__ + "img/chatbot.cf01233c.webp";